import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';

interface QueryErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  minHeight?: number | string;
}

const QueryErrorState: React.FC<QueryErrorStateProps> = ({
  title = 'Unable to load data',
  message = 'Please try again.',
  onRetry,
  retryLabel = 'Retry',
  minHeight = 220,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      gap={1.5}
      minHeight={minHeight}
      width="100%"
    >
      <Alert severity="error">
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="body2">{message}</Typography>
      </Alert>
      {onRetry ? (
        <Box>
          <Button variant="outlined" onClick={onRetry}>
            {retryLabel}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default QueryErrorState;
